import React from 'react';
import { Box, Card, CardContent, Typography, TextField, InputAdornment, IconButton, Link, Stack } from '@mui/material';
import { Visibility, VisibilityOff, Email, Lock } from '@mui/icons-material';
import { Controller } from 'react-hook-form';

import { CustomButton } from '../../common-components/CustomButton';
import useFormHandler from './hooks/useFormHandler';

export default function LoginPage() {
  const { control, handleSubmit: onSubmit, errors, isSubmitting, showPassword, setShowPassword, isLoading } = useFormHandler();

  return (
    <Box sx={{ width: '100%', px: 2 }}>
      <Card sx={{ width: '100%', maxWidth: 420, mx: 'auto', boxShadow: '0 8px 24px rgba(0,0,0,0.08)' }}>
        <CardContent sx={{ p: 4 }}>
          <Stack spacing={3}>
            <Box>
              <Typography variant="h4" gutterBottom>
                Welcome back
              </Typography>
              <Typography variant="body2">Sign in to continue to your workspace</Typography>
            </Box>

            <Box component="form" onSubmit={onSubmit} noValidate>
              <Stack spacing={2.5}>
                <Controller
                  name="email"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      type="email"
                      //   label="Email address"
                      placeholder="you@example.com"
                      fullWidth
                      error={!!errors.email}
                      helperText={errors.email?.message}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Email fontSize="small" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />

                <Controller
                  name="password"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      type={showPassword ? 'text' : 'password'}
                      //   label="Password"
                      placeholder="Enter your password"
                      fullWidth
                      error={!!errors.password}
                      helperText={errors.password?.message}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Lock fontSize="small" />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton aria-label="toggle password visibility" edge="end" onClick={() => setShowPassword((s) => !s)}>
                              {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />

                <CustomButton type="submit" fullWidth disabled={isSubmitting || isLoading} sx={{ mt: 0.5 }}>
                  Sign in
                </CustomButton>
              </Stack>
            </Box>

            <Typography variant="caption" sx={{ textAlign: 'center' }}>
              By continuing, you agree to our{' '}
              <Link href="#" underline="hover">
                Terms
              </Link>{' '}
              and{' '}
              <Link href="#" underline="hover">
                Privacy Policy
              </Link>
              .
            </Typography>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
